import { Component, Input } from '@angular/core';

@Component({
    selector: 'cl-side-filters',
    templateUrl: './side-filters.component.html',
    styleUrls: ['./side-filters.component.scss']
})
export class SideFiltersComponent {
    static $name: string = 'clSideFilters';

    @Input() lockOpened = false;

    showFiller = false;

    constructor() {
    }
}
